import React from 'react';
import './line-block.css';

export default () => (
  <div className="line-block">
    <div className="line-man line-man-1" />
    <div className="line-man line-man-2" />
    <div className="line line-1" />
    <div className="line line-2" />
    <div className="line-s" />
  </div>
);



// WEBPACK FOOTER //
// ./src/blocks/VideoBlock/LineBlock/index.js